/*=========================================================================================
  File Name: store.js
  Description: Vuex store
----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
// Persister state
import createPersistedState from 'vuex-persistedstate';

import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

// Modules
import auth from './modules/auth/moduleAuth';
import customer from './modules/customer/moduleCustomer.js';
import product from './modules/products/moduleProduct.js';
import stock from './modules/stock/moduleStock.js';
import purchase from './modules/purchase/modulePurchase.js';
import purchaseOrder from './modules/purchase-order/modulePurchaseOrder.js';
import purchaseReturn from './modules/purchase-return/modulePurchaseReturn.js';
import supplier from './modules/supplier/moduleSupplier.js';
import user from './modules/user/moduleUser.js';
import warehouse from './modules/warehouse/moduleWarehouse.js';
import brand from './modules/brand/moduleBrand';
import Unit from './modules/unit/moduleUnitStore';
import discount from './modules/Discount/moduleDiscount';
import sales from './modules/Sales/moduleSales.js';
import shop from './modules/shop/moduleShop.js';
import chequeManagement from './modules/cheque-management/moduleChequeManagement.js';
import report from './modules/reports/moduleReport.js';
import common from './modules/common/moduleCommon.js';
import sitesetting from './modules/site-setting/moduleSiteseting';
import book from './modules/book/moduleBook';
import DocumentUpload from './modules/DocumentUpload/moduleDocumentUpload';
import ExpenseSetting from './modules/expensesetting/moduleExpenseSetting';
import expense from './modules/expense/moduleExpense';
import event from './modules/event/moduleEvent';
import sms from './modules/sms/moduleSms';

export default new Vuex.Store({
  plugins: [createPersistedState()],
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth,
    brand,
    book,
    customer,
    product,
    stock,
    common,
    purchase,
    purchaseOrder,
    purchaseReturn,
    supplier,
    user,
    warehouse,
    Unit,
    discount,
    sitesetting,
    shop,
    sales,
    chequeManagement,
    report,
    DocumentUpload,
    ExpenseSetting,
    expense,
    event,
    sms,
  },
});
